import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthProvider";
import { showGuideOnFirstVisit, type Guide } from "./guides";

// The page shows first and the guide follows, so it reads as a guide to this page.
const SETTLE_MS = 1200;

/** Opens `guide` the first time `eligible` holds, never over the terms dialog. */
export function useFirstVisit(guide: Guide, eligible: boolean): void {
  const { tosAccepted, ppAccepted } = useAuth();
  const consented = !!tosAccepted && !!ppAccepted;
  useEffect(() => {
    if (!eligible || !consented) return;
    const timer = setTimeout(() => showGuideOnFirstVisit(guide), SETTLE_MS);
    return () => clearTimeout(timer);
  }, [guide, eligible, consented]);
}
